<template>
    <div class="row">
        <div class="col-md-12">
            <h2 class="text-black">{{title}}</h2>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'OrderHeader',
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>
